export function isE2ETests(): boolean {
  return navigator.webdriver;
}
